import React from "react";
import styled from "styled-components";
import ShimmerView from "./ShimmerView";
import PromoWidgetShimmer from "./promoWidget/PromoWidgetShimmer";
import ReferralsShimmer from "./referrals/ReferralsShimmer";
import ReferralEarningsShimmer from "./referralEarnings/ReferralEarningsShimmer";
import ReferralViewShimmer from "./referralView/ReferralViewShimmer";

const PageContainer = styled.div`
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Secondary};
    min-height: 100vh; /* Fallback for older browsers */
    min-height: 100svh; /* Small viewport height - accounts for mobile browser UI */
`;

const MastheadWrapper = styled.div(({ theme }) => ({
    width: "100%",
    height: 200,
    marginTop: theme.spacing.xSmall,
    marginBottom: theme.spacing.xSmall,
    overflow: "hidden",
}));

const ContentContainer = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
}));

const FeatureCardsWrapper = styled.div(({ theme }) => ({
    width: "100%",
    height: 180,
    borderRadius: theme.spacing.medium,
    marginTop: theme.spacing.xSmall,
    marginBottom: theme.spacing.xSmall,
    overflow: "hidden",
}));

const FullPageShimmer = () => {
    return (
        <PageContainer>
            <MastheadWrapper>
                <ShimmerView />
            </MastheadWrapper>
            <ContentContainer>
                <FeatureCardsWrapper>
                    <ShimmerView />
                </FeatureCardsWrapper>
                <ReferralViewShimmer />
                <PromoWidgetShimmer />
                <ReferralsShimmer />
                <ReferralEarningsShimmer />
            </ContentContainer>
        </PageContainer>
    );
};

export default FullPageShimmer;
